// @flow
import * as message from "./message";

export default message;
